<template>
  <div class="w-100">
    <div class="w-100 mb-3 d-flex justify-content-between addt_srv_cart" v-for="(product,product_i) in products">
      <div class="image">
        <img :src="product.image_url" class="img-fit" >
      </div>
      <div class="w-100 px-3">
        <p class="mb-0 text-white body-2-4">{{product.name}}</p>
        <div class="d-flex align-items-center mb-1">
          <p class="text-12 font-lato mb-0 text-white">{{ $formatCurrency(product.price.finalWithTax) }}</p>
          <p class="text-10 font-lato-regular text-white mb-0 text-line-through ml-2" v-if="product.promotion.promotionName">{{ $formatCurrency(product.price.baseWithTax) }}</p>
        </div>
        <p class="mb-0 body-3 text-white">{{product.qty}} {{ product.unit ? product.unit : 'x' }}</p>
      </div>
      <div class="remove-btn" @click="removeProduct(product)">
        <svg width="15" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_201_6878)">
            <path
              d="M4.96216 14.3925C4.67027 14.3925 4.48316 14.2204 4.46819 13.936L4.24366 5.69563C4.23617 5.41871 4.42328 5.23908 4.72266 5.23908C4.99958 5.23908 5.19418 5.41123 5.20166 5.68815L5.44116 13.936C5.44865 14.2129 5.25405 14.3925 4.96216 14.3925ZM7.24494 14.3925C6.953 14.3925 6.75093 14.2129 6.75093 13.936V5.69563C6.75093 5.41871 6.953 5.23908 7.24494 5.23908C7.53681 5.23908 7.74636 5.41871 7.74636 5.69563V13.936C7.74636 14.2129 7.53681 14.3925 7.24494 14.3925ZM9.53514 14.3925C9.24327 14.3925 9.04867 14.2129 9.05614 13.936L9.28817 5.69563C9.29564 5.41123 9.49024 5.23908 9.76717 5.23908C10.0665 5.23908 10.2536 5.41871 10.2462 5.69563L10.0216 13.936C10.0067 14.2204 9.81954 14.3925 9.53514 14.3925ZM3.95925 3.42037H5.14927V1.81871C5.14927 1.3921 5.44865 1.11517 5.89772 1.11517H8.57714C9.02619 1.11517 9.32559 1.3921 9.32559 1.81871V3.42037H10.5156V1.74387C10.5156 0.658628 9.81207 0 8.65946 0H5.81538C4.66278 0 3.95925 0.658628 3.95925 1.74387V3.42037ZM0.56133 4.01913H13.936C14.2428 4.01913 14.4898 3.75717 14.4898 3.45031C14.4898 3.14345 14.2428 2.88898 13.936 2.88898H0.56133C0.261954 2.88898 0 3.14345 0 3.45031C0 3.76466 0.261954 4.01913 0.56133 4.01913ZM3.81705 16.6678H10.6803C11.7505 16.6678 12.469 15.9717 12.5214 14.9014L13.0453 3.86196H1.44449L1.97588 14.909C2.02827 15.9792 2.73181 16.6678 3.81705 16.6678Z"
              fill="#DC3545" />
          </g>
          <defs>
            <clipPath id="clip0_201_6878">
              <rect width="14.4898" height="18" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['products'],
    methods:{
      removeProduct(product){
        this.$emit('removeProduct', product)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/hotel/be/additionalService/ProductCartPrimaryStyle.vue